import React from "react";
import { useTranslation } from "react-i18next";
import { SupportDistrictApi } from "../../../../../../../../../services/support/types";
import DropdownList from "../../../../SearchOrganization/components/DropdownList";

interface Props {
	data: SupportDistrictApi[];
	dataLoading: boolean;
}

const DistrictListTable = ({ data, dataLoading }: Props) => {
	const { t } = useTranslation("admin");
	const headerColumns = [
		{
			id: "id",
			title: "ID",
		},
		{
			id: "city_value",
			title: t("lib:common.address.city"),
		},
		{
			id: "city_slug",
			title: t("modules.support.field.city_slug.title"),
		},
		{
			id: "street_value",
			title: t("lib:common.address.street"),
		},
		{
			id: "street_slug",
			title: t("modules.support.field.street_slug.title"),
		},
		{
			id: "country_code",
			title: t("modules.support.field.country_code.title"),
		},
		{
			id: "district",
			title: t("modules.support.field.district.title"),
		},
	];

	const getDataColumns = (item: SupportDistrictApi) => [
		<>{item.id}</>,
		<>{item.city_value}</>,
		<>{item.city_slug}</>,
		<>{item.street_value}</>,
		<>{item.street_slug}</>,
		<>{item.country_code}</>,
		<>{item.district}</>,
	];

	return (
		<div className="my-4">
			<DropdownList
				title={t("modules.support.field.districts.title")}
				headerColumns={headerColumns}
				dataColumns={getDataColumns}
				items={data}
				loading={dataLoading}
			/>
		</div>
	);
};

export default DistrictListTable;
